// Loop Cart Integration
(function() {
  'use strict';
  
  // Store for Loop bundle data
  window.LoopCartData = {
    bundleItems: [],
    totalItems: 0,
    bundleId: null,
    progress: 0,
    targetMeals: 0, // 10, 15, 18, or 21
    isLoopBundle: false
  };
  let loopBundleRenderTimer = null;
  
  // Function to update cart count display (only on Loop bundle pages)
  function updateCartCount() {
    if (!window.LoopCartData.isLoopBundle) return;
    const cartBubble = document.querySelector('#cart-icon-bubble span');
    const mobileCartBubble = document.querySelector('#mobile-cart-icon-bubble span');
    
    if (cartBubble) {
      cartBubble.textContent = window.LoopCartData.totalItems;
      cartBubble.parentElement.style.display = window.LoopCartData.totalItems > 0 ? 'block' : 'none';
    }
    
    if (mobileCartBubble) {
      mobileCartBubble.textContent = window.LoopCartData.totalItems;
      mobileCartBubble.parentElement.style.display = window.LoopCartData.totalItems > 0 ? 'block' : 'none';
    }
    
    // Update Alpine store if available
    if (window.AlpineSafety) {
      window.AlpineSafety.safeStore('xCartHelper', 'currentItemCount', window.LoopCartData.totalItems);
    } else if (window.Alpine && Alpine.store('xCartHelper')) {
      try {
        Alpine.store('xCartHelper').currentItemCount = window.LoopCartData.totalItems;
      } catch (error) {
        // Alpine store not ready yet
      }
    }
  }
  
  // Function to check if we're on a Loop bundle page
  function checkLoopBundlePage() {
    const isLoopPage = window.location.href.includes('/a/loop_subscriptions/bundle/');
    window.LoopCartData.isLoopBundle = isLoopPage;
    
    if (isLoopPage) {
      monitorBundleProgress();
    }
    
    return isLoopPage;
  }
  
  // Function to monitor bundle progress on Loop pages
  function monitorBundleProgress() {
    // Check for bundle items every 2 seconds
    const progressInterval = setInterval(() => {
      if (!window.location.href.includes('/a/loop_subscriptions/bundle/')) {
        clearInterval(progressInterval);
        return;
      }
      
      // Look for bundle items in the DOM
      const bundleItems = document.querySelectorAll('[data-loop-item], .loop-bundle-item, [class*="bundle-item"]');
      const bundleTitle = document.querySelector('.loop-bundle-title, [class*="bundle-title"]');
      
      if (bundleItems.length > 0) {
        const newTotalItems = bundleItems.length;
        const bundleName = bundleTitle ? bundleTitle.textContent.trim() : 'WEEK to WEEK';
        
        // Update our data
        window.LoopCartData.bundleItems = Array.from(bundleItems).map(item => ({
          title: item.querySelector('[class*="title"], [class*="name"]')?.textContent?.trim() || 'Meal',
          quantity: 1
        }));
        window.LoopCartData.totalItems = newTotalItems;
        window.LoopCartData.progress = Math.min((newTotalItems / 21) * 100, 100); // Max 21 meals
        
        // Determine target based on current count
        if (newTotalItems >= 21) window.LoopCartData.targetMeals = 21;
        else if (newTotalItems >= 18) window.LoopCartData.targetMeals = 18;
        else if (newTotalItems >= 15) window.LoopCartData.targetMeals = 15;
        else if (newTotalItems >= 10) window.LoopCartData.targetMeals = 10;
        else window.LoopCartData.targetMeals = 10;
        
        // Save to localStorage
        localStorage.setItem('loopCartData', JSON.stringify(window.LoopCartData));
      }
    }, 2000);
  }
  
  // Function to load saved bundle data
  function loadSavedBundleData() {
    try {
      const savedData = localStorage.getItem('loopCartData');
      if (savedData) {
        const data = JSON.parse(savedData);
        window.LoopCartData = { ...window.LoopCartData, ...data };
        updateCartCount();
        return true;
      }
    } catch (error) {
      console.error('Error loading saved bundle data:', error);
    }
    return false;
  }
  
  // Function to make cart icon functional (only on Loop bundle pages)
  function makeCartIconFunctional() {
    if (!window.LoopCartData.isLoopBundle) return;
    const cartIcon = document.querySelector('#cart-icon, [data-cart-icon], .cart-icon');
    const mobileCartIcon = document.querySelector('#mobile-cart-icon, [data-mobile-cart-icon]');
    
    function handleCartClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (window.LoopCartData.totalItems > 0) {
        // If we have bundle items, redirect to Loop bundle page
        if (window.LoopCartData.bundleId) {
          window.location.href = `/a/loop_subscriptions/bundle/${window.LoopCartData.bundleId}`;
        } else {
          // Fallback to menu page
          window.location.href = '/pages/our-plans';
        }
      } else {
        // If no items, go to menu page
        window.location.href = '/pages/our-plans';
      }
    }
    
    if (cartIcon) {
      cartIcon.addEventListener('click', handleCartClick);
      cartIcon.style.cursor = 'pointer';
    }
    
    if (mobileCartIcon) {
      mobileCartIcon.addEventListener('click', handleCartClick);
      mobileCartIcon.style.cursor = 'pointer';
    }
  }

  // Reset and clear saved Loop data
  function resetLoopCartData() {
    window.LoopCartData = {
      bundleItems: [],
      totalItems: 0,
      bundleId: null,
      progress: 0,
      targetMeals: 0,
      isLoopBundle: false
    };
    try { localStorage.removeItem('loopCartData'); } catch (e) {}
  }

  async function fetchShopifyCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  // Keep local storage in sync with actual Shopify cart
  async function syncWithShopifyCart() {
    const cart = await fetchShopifyCart();
    if (!cart || typeof cart.item_count !== 'number') return null;
    if (cart.item_count === 0) {
      resetLoopCartData();
    }
    return cart;
  }

  function hasLoopBundleContainer() {
    return Boolean(
      document.querySelector('.LOOP_flexpro-meals_bundles') ||
      document.querySelector('.LOOP_flexpro-meals_bundles_drawer')
    );
  }

  async function refreshLoopBundleMarkup() {
    if (!hasLoopBundleContainer()) return;
    if (typeof initLoopBundle !== 'function') return;

    const cart = await fetchShopifyCart();
    if (!cart || !Array.isArray(cart.items)) return;

    const hasBundleItems = cart.items.some((item) => {
      return item?.properties?._bundleId || item?.properties?.bundleId;
    });

    if (!hasBundleItems) return;

    window.Loop = window.Loop || {};
    window.Loop.bundleCartAllItems = cart.items;

    if (document.querySelector('.LOOP_flexpro-meals_bundles')) {
      await initLoopBundle('LOOP_flexpro-meals_bundles');
    }

    if (document.querySelector('.LOOP_flexpro-meals_bundles_drawer')) {
      await initLoopBundle('LOOP_flexpro-meals_bundles_drawer');
    }
  }

  function scheduleLoopBundleRefresh(delay = 150) {
    clearTimeout(loopBundleRenderTimer);
    loopBundleRenderTimer = setTimeout(() => {
      refreshLoopBundleMarkup();
    }, delay);
  }
  
  // Function to show bundle progress indicator
  function showBundleProgress() {
    if (window.LoopCartData.totalItems === 0) return;
    
    // Create or update progress indicator
    let progressIndicator = document.querySelector('.loop-progress-indicator');
    if (!progressIndicator) {
      progressIndicator = document.createElement('div');
      progressIndicator.className = 'loop-progress-indicator';
      progressIndicator.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #d4a017;
        color: white;
        padding: 15px;
        border-radius: 10px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 1000;
        max-width: 300px;
        font-size: 14px;
      `;
      document.body.appendChild(progressIndicator);
    }
    
    const progress = window.LoopCartData.progress;
    const items = window.LoopCartData.totalItems;
    const target = window.LoopCartData.targetMeals;
    
    progressIndicator.innerHTML = `
      <div style="margin-bottom: 8px; font-weight: bold;">Bundle Progress</div>
      <div style="margin-bottom: 8px;">${items} / ${target} meals</div>
      <div style="background: rgba(255,255,255,0.3); height: 6px; border-radius: 3px; overflow: hidden;">
        <div style="background: white; height: 100%; width: ${progress}%; transition: width 0.3s;"></div>
      </div>
      <div style="margin-top: 8px; font-size: 12px;">
        ${items >= target ? 'Ready to checkout!' : `Add ${target - items} more meals to checkout`}
      </div>
    `;
  }
  
  // Initialize when DOM is ready
  function initialize() {
    // Determine current context first
    checkLoopBundlePage();

    // Keep storage in sync with the actual Shopify cart
    syncWithShopifyCart();
    scheduleLoopBundleRefresh();

    // Only apply Loop UI behaviors on Loop pages
    if (window.LoopCartData.isLoopBundle) {
      // Load saved data for Loop context
      loadSavedBundleData();

      // Make cart icon go to Loop bundle editor
      makeCartIconFunctional();

      // Show progress indicator if we have items
      if (window.LoopCartData.totalItems > 0) {
        showBundleProgress();
      }

      // Update cart count UI on Loop pages
      updateCartCount();
    }
  }
  
  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Monitor for URL changes
  let lastUrl = window.location.href;
  const urlObserver = new MutationObserver(() => {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      setTimeout(() => {
        checkLoopBundlePage();
        if (window.LoopCartData.isLoopBundle) {
          if (window.LoopCartData.totalItems > 0) {
            showBundleProgress();
          }
          updateCartCount();
        }
      }, 1000);
    }
  });
  
  urlObserver.observe(document.body, { childList: true, subtree: true });
  
  // Export functions for external use
  window.LoopCartIntegration = {
    updateCartCount,
    showBundleProgress,
    makeCartIconFunctional,
    loadSavedBundleData,
    refreshLoopBundleMarkup
  };

  // Listen for theme cart updates to clear stale Loop data when cart is emptied
  document.addEventListener('eurus:cart:items-changed', () => {
    syncWithShopifyCart();
    scheduleLoopBundleRefresh();
  });
  // Handle bfcache restores
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      syncWithShopifyCart();
      scheduleLoopBundleRefresh(0);
    }
  });
  
})(); 
